export default __webpack_public_path__ + "static/media/Shu'kusht.8f48c2e8.jpg";